export default __webpack_public_path__ + "resources/icons/d500-f272.webp";